import { INCREMENT } from "../cart/actiontypes";

const stockOut = (store) => (next) => (action) => {
    let state = store.getState();
    let stockOut = false;
    if(action.type === INCREMENT ){
        state.cart.forEach((x)=>{
            if(action.payload===x.id){
                if(x.inStock===0){
                    stockOut =true
                }
            }
        })
    }


    if(!stockOut){
        return next(action)
    }else{
        alert('Stock out')
    }

};

export default stockOut;
